module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp1-f2427d3871d546a6cc4913b087d58aef.jpg";